import { COLOR } from 'admin/constants/styles';
import { applyToTargetValue } from 'admin/utils';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { InputErrors } from './WithErrors';

type Props = {
  value?: string;
  setValue?: (value: string) => void;
  innerRef?: React.Ref<HTMLInputElement>;
  errors?: string[];
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = styled.input`
  padding: 5px;
  border-radius: 3px;
  border: 1px solid ${COLOR.lightGray};
  outline: none;
  background: none;
`;

const NumberInput = forwardRef<HTMLInputElement, Props>(
  ({ value, setValue, className, innerRef, errors, ...rest }: Props, ref) => (
    <InputErrors errors={errors}>
      <Input
        ref={innerRef || ref}
        className={className}
        value={value}
        onChange={applyToTargetValue(setValue)}
        type="number"
        {...rest}
      />
    </InputErrors>
  )
);

export default styled(NumberInput)``;
